const STORAGE_KEY = "agentframer_last_auth_provider";
const CONFIRMED_KEY = "agentframer_last_auth_provider_confirmed";
const PENDING_KEY = "agentframer_pending_auth_provider";

export type AuthProvider = "google" | "email";

export function setLastAuthProvider(provider: AuthProvider) {
	try {
		localStorage.setItem(STORAGE_KEY, provider);
		localStorage.setItem(CONFIRMED_KEY, "1");
	} catch {
		// localStorage unavailable (SSR, private mode, etc.)
	}
}

export function getLastAuthProvider(): AuthProvider | null {
	try {
		if (localStorage.getItem(CONFIRMED_KEY) !== "1") {
			localStorage.removeItem(STORAGE_KEY);
			return null;
		}
		const value = localStorage.getItem(STORAGE_KEY);
		if (value === "google" || value === "email") {
			return value;
		}
	} catch {
		// localStorage unavailable
	}
	return null;
}

/** Store pending social provider, promoted to "last used" only on confirmed session */
export function setPendingAuthProvider(provider: AuthProvider) {
	try {
		sessionStorage.setItem(PENDING_KEY, provider);
	} catch {}
}

export function clearPendingAuthProvider() {
	try {
		sessionStorage.removeItem(PENDING_KEY);
	} catch {}
}

/** Call this when a session is confirmed. Returns true if a pending provider was promoted. */
export function confirmPendingAuthProvider(hasSession: boolean): boolean {
	if (!hasSession) return false;
	try {
		const value = sessionStorage.getItem(PENDING_KEY);
		if (value === "google" || value === "email") {
			setLastAuthProvider(value as AuthProvider);
			sessionStorage.removeItem(PENDING_KEY);
			return true;
		}
	} catch {}
	return false;
}
